import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './hooks/useAuth'
import App from './App.jsx'
import './index.css'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Polling is OPT-IN, not global.
      //
      // These defaults used to refetch EVERY query every 60s and on every window
      // focus. With heavy admin endpoints (e.g. /admin/clients paginates every
      // current-month order) an open tab re-read the database once a minute all
      // day — the dominant source of Supabase egress, which blew the plan quota.
      //
      // Now: data still refreshes on mount, on reconnect, and whenever a
      // mutation invalidates it — so nothing goes stale in practice — but a
      // parked tab costs nothing. Views that genuinely need live data (sync
      // health, worker heartbeats, background-job progress) set their own
      // refetchInterval per query.
      staleTime: 1000 * 60,               // 60s
      retry: 1,
      refetchOnWindowFocus: false,        // was true — re-ran everything on tab switch
      refetchOnReconnect: true,           // cheap, and only after a dropped connection
      refetchInterval: false,             // was 60s globally — now per-query opt-in
      refetchIntervalInBackground: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
